import { TResult, makeSuccess, IEndpoint, ISgApiService } from "../../../sg-core";
import { IInitialContextResult } from "./contextService";
import IPerson from "../interfaces/IPerson";
import PersonMapper from "../mappers/PersonMapper";
import { DropdownItemProps } from "semantic-ui-react";
import { HPR } from "../../endpoints";

export interface IGetPersonsResult {
    success: true;
    action: "etsi_henkilo_nimella";
    henkilot: any[]
};

export interface IPersonsByRoleResult {
    success: true;
    action: "listaa_henkilot";
    henkilot: IInitialContextResult["henkilot"];
};

export interface IPersonsToDelegateResult {
    success: true;
    action: "listaa_henkilot";
    lista: { id: number; teksti: string; meiliosoite: string; }[];
};

export interface IPersonService {
    getPersons(personIds: number[]): Promise<TResult<IPerson[]>>;
    getPersonsByRole(role: string): Promise<TResult<IPerson[]>>;
    getPersonsToDelegate: (textInput?: string) => Promise<TResult<DropdownItemProps[]>>;
};

export const getPersonService = (apiService: ISgApiService, Enpoint: IEndpoint, anonymousSession: boolean): IPersonService => {

    const makeAnonymousAction = (actionName: string) => anonymousSession ? `${actionName}_anonyymi` : actionName;

    const Action: { [K in keyof IPersonService]: string; } = {
        getPersons: makeAnonymousAction("listaa_henkilot_avaimella"),
        getPersonsByRole: makeAnonymousAction("listaa_henkilot"),
        getPersonsToDelegate: "etsi_delegointi_kasittelija",
    };

    const getPersons = async (personIds: number[]): Promise<TResult<IPerson[]>> => {
        const action = Action.getPersons;
        const reqBody = {
            avainlista: personIds.join(','),
            //    patevyyslista: certList.join(',')
        }
        const apiResponse: any = await apiService.sendAction<IGetPersonsResult>(HPR, action, reqBody);
        if (apiResponse.isSuccess === true) {
            const persons = (apiResponse.value.henkilot || []).map(PersonMapper.apiToDomain)
            return makeSuccess(persons);
        }

        return apiResponse;
    };


    const getPersonsByRole = async (role: string): Promise<TResult<IPerson[]>> => {
        const action = Action.getPersonsByRole;
        const body = { haku: { rooli: role } };
        const apiResponse = await apiService.sendAction<IPersonsByRoleResult>(Enpoint, action, body);

        if (apiResponse.isSuccess === true) {
            return makeSuccess(apiResponse.value.henkilot.map(PersonMapper.apiToDomain));
        }

        return apiResponse
    };

    const getPersonsToDelegate = async (textInput: string = ""): Promise<TResult<DropdownItemProps[]>> => {
        const action = Action.getPersonsToDelegate;
        const body = { haku: { nimi: textInput } };
        const apiResponse = await apiService.sendAction<IPersonsToDelegateResult>(Enpoint, action, body);

        if (apiResponse.isSuccess === true) {
            return makeSuccess(apiResponse.value.lista.map((opt) => ({
                text: opt.teksti,
                value: opt.id,
                data: {
                    id: opt.id,
                    fullname: opt.teksti,
                    email: opt.meiliosoite
                },
                key: opt.id
            })));
        }

        return apiResponse
    };

    return {
        getPersons,
        getPersonsByRole,
        getPersonsToDelegate
    };
};